import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { space, typography } from "styled-system";
import { color, textTransform } from "./css";
var sharedStyles = {
  name: "120lo9r-base",
  styles: "label:base;margin:0;"
};
var textStyles = [sharedStyles, color, space, textTransform, typography];

var Text = /*#__PURE__*/_styled("p", {
  shouldForwardProp: shouldForwardProp,
  target: "edtjr6f0"
}).apply(void 0, textStyles);

Text.displayName = "Text";
export var Span = /*#__PURE__*/_styled("span", {
  shouldForwardProp: shouldForwardProp,
  target: "edtjr6f1"
}).apply(void 0, textStyles);
Span.displayName = "Span";
export default Text;